import { DownloadOutlined } from '@ant-design/icons'

import { BranchCashAction } from '@pages/Branch/CashPage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchCashAction) => void
}

export default function BranchCashTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [
    { label: '다운로드', buttonType: 'dashed', icon: <DownloadOutlined />, onClick: () => onAction('export') },
    { label: '현금 추가', buttonType: 'primary', onClick: () => onAction('add') },
  ]

  return <PageTitle title="현금" actions={actions} />
}
